export const visit = (vm, at) => {
at({ "da": { "conversations-message-history": { "status": { "closed": "Denne tr\xE5d blev lukket den {{ dateString }}", "restore": "Gendan denne besked", "publishing": { "UNPUBLISHED": "Sender... ", "PUBLISH_FAILED": "Ikke leveret. Klik for at pr\xF8ve igen." } } } } });
};